import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
function PrivacyContent() {
  return <>
      <p className="text-xs text-slate-400 italic" data-id="element-106">
        Última actualización: marzo 2026
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-107">
        1. Información que recopilamos
      </h3>
      <p data-id="element-108">
        Cuando adquieres IA Express 2026, recopilamos la información necesaria
        para procesar tu compra, incluyendo tu nombre, dirección de correo
        electrónico y datos de pago. Esta información es procesada de forma
        segura a través de nuestros proveedores de pago autorizados.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-109">
        2. Uso de la información
      </h3>
      <p data-id="element-110">
        Utilizamos tu información personal exclusivamente para: entregar el
        producto digital adquirido, enviarte actualizaciones relacionadas con tu
        compra, brindarte soporte técnico si lo necesitas y mejorar nuestros
        productos y servicios.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-111">
        3. Protección de datos
      </h3>
      <p data-id="element-112">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. No vendemos, intercambiamos ni
        transferimos tu información personal a terceros sin tu consentimiento.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-113">
        4. Cookies y tecnologías similares
      </h3>
      <p data-id="element-114">
        Nuestro sitio puede utilizar cookies y tecnologías similares para
        mejorar tu experiencia de navegación y analizar el tráfico del sitio.
        Puedes configurar tu navegador para rechazar cookies, aunque esto podría
        afectar algunas funcionalidades.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-115">5. Tus derechos</h3>
      <p data-id="element-116">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. También puedes solicitar la limitación del
        procesamiento de tus datos o ejercer tu derecho a la portabilidad de
        datos.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-117">
        6. Cambios en esta política
      </h3>
      <p data-id="element-118">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Te notificaremos sobre cambios significativos a
        través del correo electrónico asociado a tu compra.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-slate-400 italic" data-id="element-119">
        Última actualización: marzo 2026
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-120">
        1. Aceptación de los términos
      </h3>
      <p data-id="element-121">
        Al adquirir IA Express 2026, aceptas estos términos y condiciones en su
        totalidad. Si no estás de acuerdo con alguno de estos términos, te
        recomendamos no realizar la compra.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-122">
        2. Naturaleza del producto
      </h3>
      <p data-id="element-123">
        IA Express 2026 es un producto digital educativo que proporciona una
        guía práctica y estrategias para iniciar un mini-negocio visual
        utilizando herramientas de Inteligencia Artificial. El contenido es
        informativo y educativo; los resultados dependen de la implementación
        individual de cada usuario.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-124">
        3. Descargo de responsabilidad sobre resultados
      </h3>
      <p data-id="element-125">
        No garantizamos resultados financieros específicos. Los ingresos y
        resultados mencionados son ejemplos ilustrativos y dependen de factores
        individuales como la dedicación, implementación, mercado local y otros
        factores fuera de nuestro control.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-126">
        4. Propiedad intelectual
      </h3>
      <p data-id="element-127">
        Todo el contenido de IA Express 2026, incluyendo textos, gráficos,
        plantillas y materiales de apoyo, está protegido por derechos de autor.
        La compra te otorga una licencia personal e intransferible para uso
        individual. Queda prohibida la reproducción, distribución o reventa del
        contenido.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-128">
        5. Acceso al producto
      </h3>
      <p data-id="element-129">
        Una vez completada la compra, recibirás acceso inmediato al contenido
        digital. Dado que se trata de un producto digital con entrega
        instantánea, todas las ventas son finales.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-130">
        6. Limitación de responsabilidad
      </h3>
      <p data-id="element-131">
        En la máxima medida permitida por la ley, no seremos responsables por
        daños indirectos, incidentales o consecuentes que surjan del uso o la
        imposibilidad de uso del producto.
      </p>

      <h3 className="text-base font-bold text-navy pt-2" data-id="element-132">7. Modificaciones</h3>
      <p data-id="element-133">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios entrarán en vigor inmediatamente después de su
        publicación. El uso continuado del producto después de cualquier
        modificación constituye la aceptación de los nuevos términos.
      </p>
    </>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-navy border-t border-white/10 py-8" data-id="element-134">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-135">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-136">
            <p className="text-slate-500 text-sm" data-id="element-137">
              © {new Date().getFullYear()} IA Express 2026. Todos los derechos
              reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-138">
              <button onClick={() => setActiveModal('privacy')} className="text-slate-400 text-sm hover:text-gold transition-colors" data-id="element-139">
                Política de Privacidad
              </button>
              <span className="text-slate-600 text-xs" data-id="element-140">•</span>
              <button onClick={() => setActiveModal('terms')} className="text-slate-400 text-sm hover:text-gold transition-colors" data-id="element-141">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-142">
        <PrivacyContent data-id="element-143" />
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-144">
        <TermsContent data-id="element-145" />
      </LegalModal>
    </>;
}